<div id="bank-account-change-request">
  <div class="main_profile">
    <div class="modal-header switch_header">
      <ng-container>
        <div class="col-lg-12 col-xl-12 col-12">
          <h3 class="profile_name pl-lg-2 pt-lg-2 pb-2 offset-0">
            Update Bank Account Request
          </h3>
        </div>
      </ng-container>
    </div>
    <div class="modal-body bg-white body-content" >
      <ng-container>
        <div class="row">
          <div class="col-lg-12 col-xl-12 col-12" >
            <h3 class="profile_body pl-lg-2 pt-lg-2 pb-2 offset-0">
              <form [formGroup]="changeRequestForm" #change_request="ngForm" class="form-group">
                <div class="form-group row padding-m">
                  <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12  col-form-label table-heading">Legal Name: <span class="text-danger">*</span></label>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <input class="form-control readonly-input" tabindex="-1" formControlName="legal_name" type="text" value="" [readonly]="true" name="legal_name" id="legal_name" title="Legal Name"/>
                    <span class="end_after_error"
                          *ngIf="changeRequestForm.controls['legal_name'].errors?.required && changeRequestForm.controls['legal_name'].touched">
                    * Please make sure the Legal Name is added in your merchant profile in the admin portal.
                  </span>
                  </div>
                </div>
                <div class="form-group row padding-m">
                  <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12  col-form-label table-heading">EIN: <span class="text-danger">*</span></label>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <input class="form-control readonly-input" tabindex="-1"  [value]="formattedEin" type="text" [readonly]="true" name="ein" id="ein" title="EIN (TAX ID)"/>
                    <span class="end_after_error"
                          *ngIf="changeRequestForm.controls['ein'].errors?.required && changeRequestForm.controls['ein'].touched">
                    * Please make sure the EIN number is added in your merchant profile in the admin portal.
                  </span>

                  </div>
                </div>
                <div class="form-group row padding-m">
                  <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12  col-form-label table-heading">Routing Number: <span class="text-danger">*</span></label>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <input  class="form-control" formControlName="routing_number" name="routing_number" id="routing_number" title="Routing Number">
                    <span class="end_after_error" *ngIf="changeRequestForm.controls['routing_number'].errors?.required && changeRequestForm.controls['routing_number'].touched">
                     * Routing number is required
                  </span>
                    <span
                      class="end_after_error"
                      *ngIf="changeRequestForm.controls['routing_number'].errors?.routingNumberInvalid && changeRequestForm.controls['routing_number'].touched"
                    >
                    * Routing number must be 9 digits and valid
                    </span>
                  </div>
                  </div>

                <div class="form-group row padding-m">
                  <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12  col-form-label table-heading">Bank Account: <span class="text-danger">*</span></label>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <input  class="form-control" formControlName="bank_account_number" name="bank_account_number" id="bank_account_number" title="Bank Account">
                    <span class="info_caption">The new account must be owned by the Legal Name and have the EIN as the Tax ID for the account</span>
                    <br>
                    <span class="end_after_error" *ngIf="changeRequestForm.controls['bank_account_number'].touched">
                      {{
                        changeRequestForm.controls['bank_account_number'].errors?.required
                          ? '* Bank account number is required'
                          : changeRequestForm.controls['bank_account_number'].errors?.minlength
                            ? '* Bank account number must be at least 4 digits'
                            : changeRequestForm.controls['bank_account_number'].errors?.maxlength
                              ? '* Bank account number must be at most 17 digits'
                              : changeRequestForm.controls['bank_account_number'].errors?.pattern
                                ? '* Bank account number must be numeric only'
                                : ''
                      }}
                      </span>

                  </div>
                </div>
                <div class="form-group row padding-m">
                  <label class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12  col-form-label table-heading">Type of Account: <span class="text-danger">*</span></label>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <select class="form-control" formControlName="type_of_account" name="type_of_account" id="type_of_account" title="Type of Account">
                      <option value="" selected>Select account type</option>
                      <option value="deposits">Deposits</option>
                      <option value="fees">Fees</option>
                      <option value="both">Both</option>
                    </select>
                    <span class="end_after_error" *ngIf="changeRequestForm.controls['type_of_account'].errors?.required && changeRequestForm.controls['type_of_account'].touched">
                     * Account type is required
                  </span>
                    <span
                      class="end_after_error"
                      *ngIf="changeRequestForm.controls['type_of_account'].errors?.pattern && changeRequestForm.controls['type_of_account'].touched"
                    >
                    * Please select a valid account type
                    </span>
                  </div>
                </div>
              </form>
            </h3>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="dropdown-footer">
    <div class="row">
      <div class="col-sm-4 col-6 pl-xl-4 pl-lg-4 offset-4">
        <button class="btn btn-outline-secondary lg-btn cancel_btn" (click)="closeAction()" >Cancel</button>
      </div>
      <div class="col-sm-4 col-6">
        <button class="btn btn-default lg-btn ok-btn" (click)=" saveChanges()" >Save</button>
      </div>
    </div>
  </div>
</div>
